var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16L5.5 12.25C5.65 11.8667 5.89167 11.5625 6.225 11.3375C6.55833 11.1125 6.93333 11 7.35 11H9V6.975C6.45 6.89167 4.3125 6.51667 2.5875 5.85C0.8625 5.18333 0 4.4 0 3.5C0 2.53333 0.975 1.70833 2.925 1.025C4.875 0.341667 7.23333 0 10 0C12.7833 0 15.1458 0.341667 17.0875 1.025C19.0292 1.70833 20 2.53333 20 3.5C20 4.4 19.1375 5.18333 17.4125 5.85C15.6875 6.51667 13.55 6.89167 11 6.975V11H12.65C13.05 11 13.4208 11.1125 13.7625 11.3375C14.1042 11.5625 14.35 11.8667 14.5 12.25L16 16H14L12.8 13H7.2L6 16H4ZM10 5C11.6167 5 13.1417 4.85833 14.575 4.575C16.0083 4.29167 17.0583 3.93333 17.725 3.5C17.0583 3.06667 16.0083 2.70833 14.575 2.425C13.1417 2.14167 11.6167 2 10 2C8.38333 2 6.85833 2.14167 5.425 2.425C3.99167 2.70833 2.94167 3.06667 2.275 3.5C2.94167 3.93333 3.99167 4.29167 5.425 4.575C6.85833 4.85833 8.38333 5 10 5Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.fbfb52fd8f90fa26203154c115fd7bf8.svg";
export { ForwardRef as ReactComponent };